import React from 'react'
import styles from './styles.module.scss'

function RequiredStar({ className }) {
  return <span className={`${styles.star} ${className}`}>*</span>
}

export default RequiredStar
